module.exports = __webpack_public_path__ + "img/alert.32bfd953.svg";